import {
  Checkbox as MuiCheckbox,
  type CheckboxProps as MuiCheckboxProps,
} from '@mui/material';
import { Icon } from '@shared/icons';

export type CheckboxProps = MuiCheckboxProps;

export const Checkbox = (props: CheckboxProps) => (
  <MuiCheckbox
    checkedIcon={<Icon name="check_box" />}
    icon={<Icon name="check_box_outline_blank" />}
    indeterminateIcon={<Icon name="indeterminate_check_box" />}
    color="default"
    {...props}
  />
);
